<form [formGroup]='modelSKUInfoForm'>
    <div id="modelSkuInfoComp" class="main_section_block">
        <div id="modelSkuHeader" class="main_section_headers">
            <img class="header_icon language_icon" alt="" /><span i18n = "@@new-sku-info.header.localized-display-name">LOCALIZED DISPLAY NAME</span>
        </div>
        <div id="modelSkuBody" class="main_section_body">


            <div id="modelSkuText" class="mb-3"><span i18n = "@@new-sku-info.main-section.display-name-desc">Configure how this model displays on IPOS in different languages.</span>
            </div>
            <div id="modelSkuData" class="form-group">
                <label for="displayName"><span i18n = "@@new-sku-info.main-section.display-name">Display Name</span>&nbsp;<span class="coral">*</span>
                    <img class="info_circle_icon" alt="" placement="right" popoverTitle="{{popDisplay}}"
                        [ngbPopover]="englishpop" container="body" alt="" triggers="mouseenter:mouseleave" />
                </label>



                <div id="modelSkuEnglishInput" class="input-group english_btn">
                    <input type="text" (input)="getDisplayValue(-1, $event.target.value)" class="form-control"
                        [value]="englishDisplayName" id="displayName" placeholder="{{englishPalceholder}}"
                        formControlName='displayName' />
                    <div id="modelSkuEnglishBtn" class="input-group-append">
                        <button class="btn btn-secondary" type="button">
                            <span i18n = "@@new-sku-info.button.english">English</span>
                        </button>
                    </div>
                </div>

                <div id="modelSkuLanguageTextInput" ngbDropdown class="input-group other_lang_btn" *ngFor="let lang of langList; let i=index">
                    <input type="text" [ngClass]="{'has-error': lang.duplicateLan}" [value]="lang.name"
                        (input)="getDisplayValue(i, $event.target.value)" class="form-control"
                        placeholder="{{langPlaceholder}}" required="true" />
                    <em class="err_icon_lang" *ngIf="lang.duplicateLan"></em>
                    <div id="modelSkuLanguageBtn" class="input-group-append">
                        <button ngbDropdownToggle class="btn btn-primary dropdown-toggle" type="button"
                            data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            {{lang.selectedLan}}
                        </button>

                        <div id="languageDataChange" ngbDropdownMenu class="dropdown-menu">
                            <ng-container *ngFor='let data of lang.listOflan'>

                                <a ngbDropdownItem *ngIf="lang.selectedLan!=data"
                                    (click)="onSelectChange(data,i)">{{data}}</a>
                            </ng-container>

                        </div>
                        <img class="cross_icon" (click)="removeLang(i)" role="button"
                    aria-label="Remove this display name" alt="{{crossIcon}}" />
                    </div>
                    <div id="duplicateErrorMsg" class="formfield_err_msg" *ngIf="lang.duplicateLan"><span i18n = "@@new-sku-info.main-section.duplicate-error-msg">A Display Name for your selected language already exists.</span>
                    </div>
                </div>

                <button type="button" *ngIf="langList.length <= 30" class="
                      btn btn-outline-primary btn-sm
                      left_icon_btn
                      gtmAddLocalDisplayName
                      add_local_name_btn
                      lang_button
                    " (click)="addLanguage()" [disabled]="disableAddLang || langIsSelected ||checkInputEmptyError">
                    <img class="plus_icon" alt="" />
                    {{addLocalizedDisplayName}}
                </button>
            </div>
        </div>
    </div>


    <div id="osSection" class="main_section_block">
        <div id="osSectionHeader" class="main_section_headers">
            <img class="header_icon os_icon" alt="" /><span i18n = "@@new-sku-info.main-section.os">OPERATING SYSTEM</span>  <span class="star">*</span>
        </div>
        <div id="osSectionBody" class="main_section_body">
            <div class="inline_check">
                <div id="windowsOsCheckbox" class="form-check">
                    <input type="checkbox" #windowsos class="form-check-input" id="windows" value="windows"
                        [checked]="isWindowsOS" (click)="isOS('Windows')" />
                    <label class="form-check-label"><span i18n = "@@new-sku-info.os.windows">Windows*</span>
                    </label>
                </div>
                <div id="chromebookOsCheckbox" class="form-check">
                    <input type="checkbox" #chromebookos class="form-check-input" id="chromebook" value="chromebook"
                        [checked]="isChromebookOS" (click)="isOS('Chromebook')" />
                    <label class="form-check-label"><span i18n = "@@new-sku-info.os.chromebook">Chromebook*</span>
                    </label>
                </div>
                <div id="linuxOsCheckbox" class="form-check">
                    <input type="checkbox" #linuxos class="form-check-input" id="linux" value="linux"
                        [checked]="isLinuxOS" (click)="isOS('Linux')" />
                    <label class="form-check-label"><span i18n = "@@new-sku-info.os.linux">Linux*/Devices with no operating systems</span>
                    </label>
                </div>
                <div id="uwpOsCheckbox" class="form-check">
                    <input type="checkbox" #uwpos class="form-check-input" id="uwp" value="uwp" [checked]="isUwpOS"
                        (click)="isOS('UWP')" />
                    <label class="form-check-label"><span i18n = "@@new-sku-info.os.uwp">UWP for Windows* in S mode</span>
                    </label>
                </div>
            </div>
        </div>
    </div>

    <!-- Enter Mode SKU: System information -->
    <div id="systemInfoSection" class="main_section_block">
        <div id="systemInfoHeader" class="main_section_headers">
            <img class="header_icon info_square_icon" alt="" /><span i18n = "@@new-sku-info.main-section.systeminfo">SYSTEM INFORMATION</span> 
        </div>
        <div id="systemInfoBody" class="main_section_body">
            <div id="systemIDLabel" class="form-group">
                <label for="systemID"><span i18n = "@@new-sku-info.main-section.systemid">System ID</span>&nbsp;<span class="coral">*</span>
                    <img class="info_circle_icon" alt="" placement="right" popoverTitle="{{systemId}}"
                        [ngbPopover]="systemidpopup" container="body" triggers="mouseenter:mouseleave" />
                </label>
                <div id="systemIdInput" class="input-group-append" *ngIf='!autoID'>
                    <input id="systemID" class="form-control" formControlName="systemID" [disabled]="isSubmitted" autocomplete="off"
                        type="text" [ngClass]="{'has-error': errorCheckSyatemId}" placeholder="{{systemIdPlaceholder}}"
                        maxlength="50" (input)="checkSystemId($event.target.value)" required />
                    <em class="err_icon" *ngIf="errorCheckSyatemId"></em>
                </div>
                <div id="autogenSystemId" class="input-group-append" *ngIf='autoID'>
                    <input [value]="valueOfSystemID" id="systemID" class="form-control" type="text" readonly />
                </div>
                <div id="duplicateSystemIdError" class="formfield_err_msg" *ngIf="isSystemIdExists">{{systemIDExistsErrorMsg}}</div>
                <div id="invalidSystemId" class="formfield_err_msg" *ngIf="errorCheckSyatemId && !isSystemIdExists"><span i18n = "@@new-sku-info.main-section.form-error-msg">System ID name contains an invalid
                    character or space. Please revise using alphanumeric uppercase without spaces.</span></div>
            </div>

            <div id="systemModelsForm" class="form-group">
                <label for="systemModels" class="reduceBottomMargin"><span i18n = "@@new-sku-info.main-section.systemmodels">System Models</span>&nbsp;<span class="coral">*</span>
                    <img class="info_circle_icon" alt="" placement="right" popoverTitle="{{systemModelsTips}}"
                        [ngbPopover]="infopop" container="body" triggers="mouseenter:mouseleave" />
                </label>
                <div id="systemModelNote" class="marginStyle"><span i18n = "@@new-sku-info.main-section.note-msg"><strong>Note: </strong>System model letters are case-sensitive, please double-check uppercase vs.
                    lowercase.</span>
                </div>
                <ng-container *ngIf='!autoID'>
                    <div id="systemModelInput" class="input-group-append">
                        <input (input)='getModelSkU(-1,$event.target.value)' class="form-control" type="text"
                            formControlName="systemModels" placeholder="{{systemModelsPlaceholder}}" />
                    </div>

                    <div id="systemModelList" class="new-input-group margin-div" *ngFor="let model of systemModelList; let i=index">
                        <input (input)="getModelSkU(i,$event.target.value)" class="form-control" type="text"
                            placeholder="{{systemModelsPlaceholder}}" />
                        <img class="cross_icon" (click)="removeModel(i)" role="button"
                            aria-label="Remove this model name" alt="{{crossIcon}}" />
                    </div>
                </ng-container>
                <ng-container *ngIf='autoID'>
                    <div class="new-input-group margin-div d-flex" *ngFor="let model of allValues; let i=index">
                        <div id="modelSkuEdit" class="inputWidth d-flex">
                        <input  [value]="editModelSKUList.get(i)?editModelSKUList.get(i):''"
                            (input)="getModelSkU(i,$event.target.value)" class="form-control" type="text"
                            placeholder="{{systemModelsPlaceholder}}" /></div>

                            <img *ngIf="i>0" class="cross_icon" (click)="removeModel(i)" role="button"
                            aria-label="Remove this model name" alt="cross_icon" />                  
                    </div>
                </ng-container>
            </div>
            <div id="addSystemModelBtn" class="form-group">
                <button type="button" (click)="addSystemModel()" class="btn btn-outline-primary btn-sm left_icon_btn gtmAddSystemModel
                                                add_system_model_btn add_button" 
                    [disabled]="checkEmptyInputField|| !disableAdd || !checkduplicateSku">
                    <img class="plus_icon" alt="" />{{addButton}}
                </button>
            </div>
        </div>
    </div>
</form>

<!-- Enter Model SKU: blocks end here -->
<div id="skuActionBtn" class="button_wrapper justify-Content" *ngIf='!autoID'>
    <button type="button" class="btn btn-outline-primary btn-lg" (click)="goBack()">
        {{cancelButton}}
    </button>
    <button type="button" class="btn btn-primary btn-lg" (click)="sendDataToDE()"
        [disabled]='!modelSKUInfoForm.valid || !isOperatingSystem.size || disableSubmit || errorCheckSyatemId || !disableAdd  || !checkduplicateSku || checkError || langIsSelected || checkInputEmptyError'>
        {{saveButton}}
    </button>
</div>
<div id="autoIdActionBtn" class="button_wrapper justify-Content" *ngIf='autoID'>
    <button type="button" class="btn btn-outline-primary btn-lg" (click)="goBack()">
        {{cancelButton}}
    </button>
    <button type="button" class="btn btn-primary btn-lg"
        [disabled]="!isOperatingSystem.size|| disableSubmit|| !checkduplicateSku || checkInputEmptyError || !disableAdd "
        (click)="sendDataToDE()">
        {{saveButton}}
    </button>
</div>


<ng-template #englishpop>
    <div id="englishPop" i18n="@@new-sku-info.tooltip.displayname">Appears on IPOS if a display name is not <div>available for the locale of the device.</div></div>
</ng-template>

<ng-template #systemidpopup>
    <div id="systemIdPop" i18n="@@new-sku-info.tooltip.systemid">All entries must be alphanumeric and uppercase with all space represented <div>as underscores, 
        e.g. WATER_FALL.<div> Note - Partner name will be prefixed to system id automatically.</div></div></div>
</ng-template>

<ng-template #infopop>

    <div id="questionInfoPop" class="d-flex"><em class="question_icon"></em>
        <span class="ml-3" i18n="@@new-sku-info.tooltip.infopop-question-icon">Add a<strong> ? </strong>anywhere in the system model to match one single
            <div>character. <strong>Example:</strong> 20ARS<strong>?</strong>123 would capture these models:
                <div>20ARSX123, 20ARS7123, 20ARS-123.</div></div></span>
    </div>
    <hr>
    <div id="starInfoPop" class="d-flex"><em class="star_icon"></em>
        <span class="ml-3" i18n="@@new-sku-info.tooltip.infopop-star-icon">Add a <strong>*</strong> anywhere in the system model to match any number
            <div>of characters. <strong>Example:</strong> 20ARS<strong>*</strong>123 capture these models:
                <div>20ARS<strong>XYZ</strong>123, 20ARS<strong>789</strong>123, 20ARS<strong>---</strong>123.</div></div></span>
    </div>
</ng-template>